import { createExtendedLocation } from './location.utils.service';
import { documentIsVisible } from '../../services/utils';
import manager from '../../store/Attributes.manager';

export default {
  activate,
  onLocationChanged
}

let lastLocation;

function activate() {
  if (documentIsVisible()) {
    onLocationChanged();
  }

  // if hash has changed always update location
  window.addEventListener('hashchange', () => onLocationChanged(true), false);
  // check location in a loop
  checkLocation();
}

function checkLocation(timeout) {
  timeout = timeout || 20000;
  window.setTimeout(() => {
    onLocationChanged();
    checkLocation(timeout);
  }, timeout);
}

function onLocationChanged(sync) {
  if (lastLocation === window.location.href) {
    return;
  }

  lastLocation = window.location.href;

  const location = createExtendedLocation(window.location, document.title);

  if (sync) {
    saveLocation(location);
  }

  return shouldSaveLocation(location)
    .then(function (hasChanged) {
      if (!hasChanged) {
        return;
      }

      saveLocation(location);
    }).catch(function (error) {
      console.error(error);
    });
}

function saveLocation(location) {
  manager.setNewLocation(location);
}

/**
 * @param {ILocation} location
 * @returns {boolean}
 */
function shouldSaveLocation(location) {
  return manager.getStoredAttribute('locations').then(function (data) {
    const rows = data.result.attribute;
    if (!Array.isArray(rows)) {
      return true;
    }
    const last = rows.pop();
    return !(last && last.href === location.href);
  });
}
